/* NY2K Maison bag (11 Oct 2026). Vanilla, no dependencies.
   - Opens the slide-in bag from the header icon and after Add to cart.
   - Quantity and remove without a page reload, on the drawer and the bag page.
   - Fresh markup comes from Shopify's bundled section rendering, so prices and
     totals are always the server's, never recomputed here.
   If anything fails it falls back to the ordinary page behaviour. */
(function () {
  'use strict';
  if (window.mxCart) return;
  window.mxCart = true;

  var d = document;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartPath = (R + 'cart').replace(/\/$/, '');
  var lastFocus = null, busy = false, enterTimer = 0;

  function drawer() { return d.querySelector('[data-mxc-drawer]'); }
  function shell() { return d.getElementById('PageContainer'); }

  function sectionIds() {
    var ids = [];
    d.querySelectorAll('[data-mxc-section]').forEach(function (el) {
      var id = el.getAttribute('data-mxc-section');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  /* Replace only the swappable part of each section, keep the shell (and its open state). */
  function swap(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-mxc-section="' + id + '"] [data-mxc-swap]');
      var cur = d.querySelector('[data-mxc-section="' + id + '"] [data-mxc-swap]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    });
    syncBadge();
    var el = drawer();
    if (el && el.classList.contains('is-open') && !el.contains(d.activeElement)) {
      var p = el.querySelector('[data-mxc-panel]');
      if (p) p.focus({ preventScroll: true });
    }
  }

  function syncBadge() {
    var src = d.querySelector('[data-mxc-count]');
    if (!src) return;
    var n = parseInt(src.getAttribute('data-mxc-count'), 10) || 0;
    d.querySelectorAll('a.ny2k-icon[href$="/cart"]').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      var b = a.querySelector('.ny2k-cart-badge');
      if (n > 0) {
        if (!b) { b = d.createElement('span'); b.className = 'ny2k-cart-badge'; a.appendChild(b); }
        b.textContent = n;
      } else if (b) { b.remove(); }
    });
  }

  function setBusy(v) {
    busy = v;
    d.querySelectorAll('[data-mxc-section]').forEach(function (el) { el.setAttribute('aria-busy', v ? 'true' : 'false'); });
  }

  function send(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function postJSON(path, body) {
    return send(R + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function reason(err, fallback) {
    return (err && (typeof err.description === 'string' ? err.description : err.message)) || fallback;
  }

  /* ---------- quantity and remove ---------- */
  function change(line, qty) {
    if (busy) return;
    var key = line.getAttribute('data-key');
    var errEl = line.querySelector('[data-mxc-err]');
    if (errEl) errEl.textContent = '';
    setBusy(true);
    var go = function () {
      postJSON('cart/change.js', { id: key, quantity: qty, sections: sectionIds(), sections_url: location.pathname })
        .then(function (cart) { swap(cart.sections); })
        .catch(function (err) {
          line.classList.remove('is-leaving');
          var live = d.querySelector('[data-mxc-line][data-key="' + key + '"] [data-mxc-err]');
          if (live) live.textContent = reason(err, 'That quantity is not available.');
        })
        .then(function () { setBusy(false); });
    };
    if (qty === 0) { line.classList.add('is-leaving'); setTimeout(go, 300); } else { go(); }
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-mxc-close]')) { e.preventDefault(); close(); return; }

    var line = t.closest('[data-mxc-line]');
    if (line) {
      var q = parseInt(line.getAttribute('data-qty'), 10) || 1;
      if (t.closest('[data-mxc-inc]')) { e.preventDefault(); change(line, q + 1); return; }
      if (t.closest('[data-mxc-dec]')) { e.preventDefault(); change(line, q - 1); return; }
      if (t.closest('[data-mxc-remove]')) { e.preventDefault(); change(line, 0); return; }
    }

    /* The bag icon opens the drawer. Modified clicks, the bag page itself and
       links inside the drawer (View bag) keep their normal behaviour. */
    var a = t.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var el = drawer();
    if (!el || el.contains(a)) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname.replace(/\/$/, '') !== cartPath) return;
    if (location.pathname.replace(/\/$/, '') === cartPath) return;
    e.preventDefault();
    open(a);
  });

  /* ---------- add to cart, from any product form ---------- */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || e.defaultPrevented) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') < 0 || !drawer()) return;
    e.preventDefault();

    var btn = f.querySelector('[type="submit"]');
    var old = f.parentNode.querySelector('.mxc-error');
    if (old) old.remove();
    var fd = new FormData(f);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', location.pathname);
    if (btn) btn.setAttribute('aria-busy', 'true');

    send(R + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (j) { swap(j.sections); open(btn); })
      .catch(function (err) {
        var p = d.createElement('p');
        p.className = 'mxc-error';
        p.setAttribute('role', 'alert');
        p.textContent = reason(err, 'Sorry, that could not be added. Please try again or call the studio.');
        f.parentNode.insertBefore(p, f.nextSibling);
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ---------- gift note on the bag page ---------- */
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mxc-note]')) return;
    postJSON('cart/update.js', { note: t.value }).catch(function () {});
  });

  /* ---------- open / close ---------- */
  function open(from) {
    var el = drawer();
    if (!el || el.classList.contains('is-open')) return;
    lastFocus = from || d.activeElement;
    var sb = window.innerWidth - d.documentElement.clientWidth;
    d.documentElement.style.overflow = 'hidden';
    if (sb > 0) d.body.style.paddingRight = sb + 'px';
    el.removeAttribute('inert');
    el.setAttribute('aria-hidden', 'false');
    var s = shell();
    if (s) s.setAttribute('inert', '');
    el.classList.add('is-entering');
    /* next frame, so the closed state is painted first and the slide runs */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open');
        var p = el.querySelector('[data-mxc-panel]');
        if (p) p.focus({ preventScroll: true });
      });
    });
    clearTimeout(enterTimer);
    enterTimer = setTimeout(function () { el.classList.remove('is-entering'); }, 1400);
  }

  function close() {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open', 'is-entering');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
    var s = shell();
    if (s) s.removeAttribute('inert');
    d.documentElement.style.overflow = '';
    d.body.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (_) {} }
    lastFocus = null;
  }

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  /* The theme editor re-renders the section: make sure the page is never left locked. */
  d.addEventListener('shopify:section:load', function () {
    var s = shell();
    if (s) s.removeAttribute('inert');
    d.documentElement.style.overflow = '';
  });

  window.mxCartOpen = open;
  window.mxCartClose = close;
})();
